module.exports = __webpack_public_path__ + "img/title_logo.767d360a.svg";